import { Div } from "@max/common-ui";
import { usePaymentContext } from "components/PaymentContextProvider";
import { getDisplayPrice } from "components/utils";
import styled, { css } from "styled-components";
import { Section } from ".";

const Divider = styled(Div)`
  border-bottom: 1px solid ${(props) => props.theme.colors.selectItemDivider};
  height: 1px;
`;

const Label = styled(Div)`
  font-size: 16px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
`;

const mobilePaddingCss = css`
  @media all and ${(props) => props.theme.media.mobile} {
    padding-left: 5%;
    padding-right: 5%;
  }
`;

const OrderSubTotal = styled(Div)`
  padding: 14px 20px;
  ${mobilePaddingCss}
`;

const OrderTotal = styled(Div)`
  padding: 18px 20px;
  ${mobilePaddingCss}
`;

const ProcessingFee = styled(Div)`
  padding: 18px 20px 5px 20px;
  ${mobilePaddingCss}
`;

const SummaryValues = () => {
  const { shoutoutDisplayPrice, shoutout } = usePaymentContext();
  const orderTotal = shoutoutDisplayPrice;
  return (
    <Section>
      <OrderSubTotal spaceBetween alignItemsEnd>
        <Div mt_5 dflex alignCenter>
          <Label>Subtotal</Label>
        </Div>
        <Div dflex alignItemsEnd>
          <Div fs_17 bold>
            {getDisplayPrice(shoutout.unitPrice)}
          </Div>
        </Div>
      </OrderSubTotal>
      <Divider />
      <ProcessingFee spaceBetween>
        <Div c_gray30 fs_17>
          Processing Fee
        </Div>
        <Div c_gray30 fs_17>
          {getDisplayPrice(shoutout.processingFeeAmount)}
        </Div>
      </ProcessingFee>
      <OrderTotal spaceBetween alignItemsEnd>
        <Div dflex>
          <Label mt_n30>Total</Label>
        </Div>
        <Div dflex alignItemsEnd>
          <Div mt_n5>
            <Div mt_n25 fs_14 mr_5>
              USD
            </Div>
          </Div>
          <Div fs_25 extraBold>
            {orderTotal}
          </Div>
        </Div>
      </OrderTotal>
    </Section>
  );
};

export default SummaryValues;
